import { Learner } from '../models/learner';
import { User } from '../models/user';
import { dateMapper } from './date.mapper';
import { managerRequestMapper } from './group-admin-request.mapper';

/**
 * Map to learner.
 * @param {object} dto Dto.
 * @returns {Learner}
 */
function fromDto(dto) {
  return new Learner({
    id: dto.id,
    firstName: dto.first_name,
    lastName: dto.last_name,
    email: dto.email,
    typeId: dto.type_id,
    jobTitle: dto.job_title,
    dateOfBirth: dto.dob,
    createdDate: new Date(dto.create_date),
    editDate: new Date(dto.edit_date),
    isVisible: dto.visible,
    active: dto.active,
    type: {
      id: dto.type.id,
      name: dto.type.name,
      code: dto.type.code,
    },
    username: dto.username,
    rbsServerId: dto.rbs_server_id,
    employeeId: dto.employee_id,
  });
}

/**
 * Map to learner dto.
 * @param {object} data Data.
 * @param {object} data.learner Learner.
 * @param {User} data.groupAdmin Group Admin.
 * @returns {object}
 */
function toDto({ learner, groupAdmin }) {
  return {
    first_name: learner.firstName,
    last_name: learner.lastName,
    email: learner.email,
    job_title: learner.jobTitle,
    dob: learner.dateOfBirth ? dateMapper.toDto(learner.dateOfBirth) : undefined,
    rbsServerId: learner.rbsServerId,
    employee_id: learner.employeeId,
    is_same_group_admin_address: learner.isSameGroupAdminAddress !== undefined ? learner.isSameGroupAdminAddress : undefined,
    address: learner.address ? {
      street: learner.address.street,
      street2: learner.address.street2,
      city: learner.address.city,
      zip: learner.address.zip,
      state_code: learner.address.stateCode,
    } : undefined,
    ...managerRequestMapper.toDto({ groupAdmin }),
  };
}

/**
 * Map to get learners dto.
 * @param {object} data Data.
 * @param {User} data.groupAdmin Group admin.
 * @param {User[]} data.excludedUsers Excluded users.
 * @returns {object}
 */
function toLearnersQueryParamDto({ groupAdmin, excludedUsers }) {
  return {
    ...managerRequestMapper.toDto({ groupAdmin }),
    exclude_ids: excludedUsers ? excludedUsers.map(user => user.id) : undefined,
  };
}

/**
 * Map error from dto to model.
 * @param {object} errorDto error dto.
 * @returns {object}
 */
function validationErrorFromDto(errorDto) {
  return {
    firstName: errorDto?.first_name,
    lastName: errorDto?.last_name,
    jobTitle: errorDto?.job_title,
    dateOfBirth: errorDto?.dob,
    email: errorDto?.email,
    employeeId: errorDto?.employee_id,
  };
}

export const learnerMapper = {
  fromDto,
  toDto,
  validationErrorFromDto,
  toLearnersQueryParamDto,
};
